export default __webpack_public_path__ + "static/buy_stargazer_iphones-d2af56daac7e73b9b5a59d49eb1c2068.png";